import { useState, useEffect, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "@/pages/LoginPage";
import DashboardLayout from "@/pages/DashboardLayout";
import ExecutiveCommand from "@/pages/ExecutiveCommand";
import SalesIntelligence from "@/pages/SalesIntelligence";
import CollectionIntelligence from "@/pages/CollectionIntelligence";
import TargetAchievement from "@/pages/TargetAchievement";
import ProjectIntelligence from "@/pages/ProjectIntelligence";
import InventoryIntelligence from "@/pages/InventoryIntelligence";
import BlockedUnits from "@/pages/BlockedUnits";
import CashflowConstruction from "@/pages/CashflowConstruction";
import StrategicInsights from "@/pages/StrategicInsights";
import AIAssistant from "@/pages/AIAssistant";
import SettingsPage from "@/pages/SettingsPage";
import SplashScreen from "@/components/SplashScreen";

function App() {
  const [token, setToken] = useState(sessionStorage.getItem("radiance_token"));
  const [username, setUsername] = useState(sessionStorage.getItem("radiance_user") || "");
  const [showSplash, setShowSplash] = useState(true);

  const handleLogin = (newToken, user) => {
    sessionStorage.setItem("radiance_token", newToken);
    sessionStorage.setItem("radiance_user", user);
    setToken(newToken);
    setUsername(user);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("radiance_token");
    sessionStorage.removeItem("radiance_user");
    setToken(null);
    setUsername("");
  };

  const handleSplashComplete = useCallback(() => {
    setShowSplash(false);
  }, []);

  const isAuthenticated = !!token;

  if (showSplash) {
    return <SplashScreen onComplete={handleSplashComplete} />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated ? <Navigate to="/dashboard" /> : <LoginPage onLogin={handleLogin} />
          }
        />
        <Route
          path="/dashboard"
          element={
            isAuthenticated ? (
              <DashboardLayout username={username} onLogout={handleLogout} token={token} />
            ) : (
              <Navigate to="/login" />
            )
          }
        >
          <Route index element={<ExecutiveCommand />} />
          <Route path="sales" element={<SalesIntelligence />} />
          <Route path="collections" element={<CollectionIntelligence />} />
          <Route path="targets" element={<TargetAchievement />} />
          <Route path="projects" element={<ProjectIntelligence />} />
          <Route path="inventory" element={<InventoryIntelligence />} />
          <Route path="blocked" element={<BlockedUnits />} />
          <Route path="cashflow" element={<CashflowConstruction />} />
          <Route path="strategic" element={<StrategicInsights />} />
          <Route path="ai-assistant" element={<AIAssistant token={token} />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
